<template>
	<v-dialog :model-value="absenceMenuStore.editModal.isOpen" @update:model-value="(val) => !val && handleCancel()" max-width="960" persistent scrollable>
		<v-card>
			<v-card-title class="d-flex justify-space-between align-center px-6 py-4">
				<div class="d-flex align-center">
					<span class="text-h6 font-weight-medium">
						{{ isEditMode ? t('edit_absence') : t('absence.action.create') }}
					</span>
					<v-chip v-if="isEditMode" size="small" variant="outlined" color="grey-darken-1" rounded="lg" class="text-caption ml-3 px-3">
						{{ getStatusName(absenceMenuStore.editModal.originalStatus) }}
					</v-chip>
				</div>
				<v-btn icon variant="text" size="small" @click="handleCancel">
					<v-icon size="20">mdi-close</v-icon>
				</v-btn>
			</v-card-title>

			<v-divider />

			<v-card-text class="pt-4">
				<UserAbsenceDialog
					ref="absenceForm"
					:model-value="absenceMenuStore.editModal.formModel"
					@update:model-value="absenceMenuStore.updateFormModel"
					:key="absenceMenuStore.editModal.absenceId ?? 'create'"
				/>
			</v-card-text>

			<v-divider />

			<v-card-actions class="px-4 py-3">
				<v-spacer />
				<v-btn text @click="handleCancel">{{ t('action_cancel') }}</v-btn>
				<v-btn text color="#10565C" :loading="saving" @click="handleSubmit">
					{{ isEditMode ? t('action_update') : t('action_add') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePlanningAbsenceMenuStore } from '@/rennovation/planning-view/store/usePlanningAbsenceMenuStore';
import UserAbsenceDialog from '../../../../../modules/users/components/dialogs/UserAbsenceDialog.vue';

const absenceMenuStore = usePlanningAbsenceMenuStore();
const { t } = useI18n();

const absenceForm = ref<InstanceType<typeof UserAbsenceDialog> | null>(null);
const saving = ref(false);

const isEditMode = computed(() => absenceMenuStore.editModal.mode === 'edit');

const emit = defineEmits<{ (e: 'saved'): void }>();

const getStatusName = (status: string | null) => (status ? t(`absence.${status}`) : '');

const handleCancel = () => {
	absenceMenuStore.closeEditModal();
};

const handleSubmit = async () => {
	const result = await absenceForm.value?.validate();
	if (!result?.valid) return;

	saving.value = true;
	const formModel = absenceMenuStore.editModal.formModel;
	const payload = {
		...formModel,
		entireDay: !formModel.startTime && !formModel.endTime,
	};

	try {
		await absenceMenuStore.saveAbsence(payload);
		const { driverId, date } = absenceMenuStore.contextMenu;
		if (driverId && date) await absenceMenuStore.refetch(driverId, date);
		emit('saved');
		handleCancel();
	} finally {
		saving.value = false;
	}
};
</script>
